<template>
    <div>
        <div style="text-align: center">
            <h3>Import Kontak</h3>
        </div>
        <br />
        <input class="form-control" type="text" v-model="inputCari" :placeholder="placeCari" />
	<ul id='ulCari' v-if="inputCari.length">
		<li class="item fruit" v-for="opsi in filteredList()" :key="opsi.name" @click="hasilPilihan(opsi)" >
		{{ opsi.name }}
		</li>
  
  </ul>
        <div class="tab-wrapper">
            <div class="atbd-tab tab-horizontal">
                <ul class="nav nav-tabs vertical-tabs" role="tablist">
                    <li class="nav-item">
                        <a class="nav-link" :class="{ active: page.one }" v-on:click="changePage('one')">Import
                            Excel</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" :class="{ active: page.two }" v-on:click="changePage('two')">Import Dari
                            Device</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" :class="{ active: page.three }" v-on:click="changePage('three')">Import Dari
                            Group Whatsapp</a>
                    </li>
                </ul>
                <div class="tab-content">
                    <div class="tab-pane fade" :class="{ 'show active': page.one }" id="tab-v-1" role="tabpanel"
                        aria-labelledby="tab-v-1-tab">
                        <form v-on:submit.prevent="addContact">
                            <label for="">File CSV*</label>
                            <input type="file" class="form-control" name="file" @change="readFile" accept=".csv"
                                required />
                            <br>
                            <p>
                                File contoh dapat diunduh
                                <a style="display: contents" href="/excel/contohxlsx.xlsx" download>
                                    disini
                                </a>, kemudian <b>save as</b> dengan format csv
                            </p>
                            <p>
                                <b>
                                    <u>
                                        Format Nomor Telepon CSV Harus
                                        Menggunakan Kode Negara
                                    </u>
                                </b>
                            </p>
                            <br />
                            <label>Masukkan Kontak Ke Group</label>
                            <multiselect v-model="selectedGroupForm" placeholder="Cari group" label="name" track-by="id" 
                                :options="groupdd" :multiple="false" :allow-empty="true" :show-labels="false"
                                @input="updateFormGroup">
                                <template slot="singleLabel" slot-scope="props">
                                    <span>{{ props.option.name }} [ID: {{ props.option.id }}]</span>
                                </template>
                                <template slot="option" slot-scope="props">
                                    <span>{{ props.option.name }} [ID: {{ props.option.id }}]</span>
                                </template>
                            </multiselect>
                            <br />
                            <button v-if="csvParseLoading"
                                class="btn btn-spinner btn-primary btn-block btn-default btn-squared text-capitalize lh-normal px-50 py-15 signIn-createBtn"
                                disabled>
                                <div class="spinner-border spinner" role="status"></div>
                                Sedang memproses data csv
                            </button>
                            <button v-else-if="!csvImportReady && !csvParseLoading" class="btn btn-danger btn-block"
                                disabled>
                                Silahkan Upload CSV Terlebih Dahulu
                            </button>
                            <button v-else-if="csvImportReady && !csvParseLoading" type="submit"
                                class="btn btn-primary btn-block">
                                Upload
                            </button>
                            <br>
                            <div v-if="csvImportReady">
                                <h5 class="text-center">== PREVIEW ==</h5>
                                <ImportPreview v-if="csvImportReady" :rows='importData' />
                            </div>
                        </form>
                    </div>
                    <div class="tab-pane fade" :class="{ 'show active': page.two }" role="tabpanel"
                        aria-labelledby="tab-v-2-tab">
                        <form action="" method="post">
                            <label for="">Device*</label>
                            <select v-model="importContact.device" class="form-control" required>
                                <option value="" selected disabled>== PILIH DEVICE ==</option>
                                <option v-for="d in device" :key="d.id" :value="d.id">
                                    {{ d.name + " (" + d.status + ")"}}</option>
                            </select>
                            <br />
                            <label>Masukkan Kontak Ke Group</label>
                            <multiselect v-model="selectedGroupImportContact" placeholder="Cari group" label="name" track-by="id" 
                                :options="groupdd" :multiple="false" :allow-empty="true" :show-labels="false"
                                @input="updateImportContactGroup">
                                <template slot="singleLabel" slot-scope="props">
                                    <span>{{ props.option.name }} [ID: {{ props.option.id }}]</span>
                                </template>
                                <template slot="option" slot-scope="props">
                                    <span>{{ props.option.name }} [ID: {{ props.option.id }}]</span>
                                </template>
                            </multiselect>
                            <br />
                            <button v-if="importContact.loading"
                                class="btn btn-primary btn-block btn-default btn-squared text-capitalize mx-auto d-block"
                                disabled>
                                <div class="spinner-border spinner" role="status"></div>
                                Loading
                            </button>
                            <button v-else type="button" class="btn btn-primary btn-block" v-on:click="syncContactGroup">
                                Sinkronisasi
                            </button>
                        </form>
                    </div>
                    <div class="tab-pane fade" :class="{ 'show active': page.three }" role="tabpanel"
                        aria-labelledby="tab-v-3-tab">
                        <form action="" method="post">
                            <label for="">Device*</label>
                            <select v-model="importGroup.device" class="form-control" :disabled="importGroup.step != 1" required>
                                <option value="" selected disabled>== PILIH DEVICE ==</option>
                                <option v-for="d in device" :key="d.id" :value="d.id">
                                    {{ d.name + " (" + d.status + ")"}}</option>
                            </select>
                            <br />
                            <div v-if="importGroup.step == 1">
                                <button v-if="importGroup.loading"
                                    class="btn btn-primary btn-block btn-default btn-squared text-capitalize mx-auto d-block"
                                    disabled>
                                    <div class="spinner-border spinner" role="status"></div>
                                    Loading
                                </button>
                                <button v-else type="button" class="btn btn-primary btn-block" v-on:click="loadDeviceGroup">
                                    Selanjutnya
                                </button>
                            </div>
                            <div v-else>
                                <label for="">Group*</label>
                                <multiselect v-model="selectedGroupForImportGroup" placeholder="Cari group" label="name" track-by="id" 
                                    :options="importGroup.loadedGroup" :multiple="false" :allow-empty="true" :show-labels="false"
                                    @input="updateImportGroupSelectedGroup">
                                    <template slot="singleLabel" slot-scope="props">
                                        <span>{{ props.option.name }} [ID: {{ props.option.id }}]</span>
                                    </template>
                                    <template slot="option" slot-scope="props">
                                        <span>{{ props.option.name }} [ID: {{ props.option.id }}]</span>
                                    </template>
                                </multiselect>
                                <br />
                                <label>Masukkan Kontak Ke Group</label>
                                <multiselect v-model="selectedGroupImportGroup" placeholder="Cari group" label="name" track-by="id" 
                                    :options="groupdd" :multiple="false" :allow-empty="true" :show-labels="false"
                                    @input="updateImportGroupGroup">
                                    <template slot="singleLabel" slot-scope="props">
                                        <span>{{ props.option.name }} [ID: {{ props.option.id }}]</span>
                                    </template>
                                    <template slot="option" slot-scope="props">
                                        <span>{{ props.option.name }} [ID: {{ props.option.id }}]</span>
                                    </template>
                                </multiselect>
                                <br />
                                <button v-if="importGroup.loading"
                                    class="btn btn-primary btn-block btn-default btn-squared text-capitalize mx-auto d-block"
                                    disabled>
                                    <div class="spinner-border spinner" role="status"></div>
                                    Loading
                                </button>
                                <button v-else type="button" class="btn btn-primary btn-block" v-on:click="syncGroup">
                                    Sinkronisasi
                                </button>
                                <button class="btn btn-danger btn-block" v-on:click="cancelImportGroup">
                                    Batal
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import ImportPreview from "@/components/forms/contact/ImportPreview.vue";
    import Multiselect from 'vue-multiselect'

    export default {
        components: {
            ImportPreview,
            Multiselect
        },
        props: ["groupdd"],
        data() {
            return {
                inputCari:"",
				placeCari:"Search Group ....",
                page: {
                    one: true,
                    two: false,
                    three: false
                },
                importData: [],
                form: {
                    name: "",
                    number: "",
                    variable: [],
                    group: null,
                },
                null_value: null,
                csvParseLoading: false,
                csvImportReady: false,
                device: [],
                importContact: {
                    loading: false,
                    device: "",
                    group: null
                },
                importGroup: {
                    step: 1,
                    loading: false,
                    device: "",
                    loadedGroup: [],
                    selectedGroup: null,
                    group: null
                },
                selectedGroupForm: null,
                selectedGroupImportContact: null,
                selectedGroupImportGroup: null,
                selectedGroupForImportGroup: null
            };
        },
        mounted() {
            this.getDevice()
        },
        methods: {
            filteredList() {
			return  this.groupdd.filter((opsi) =>
				opsi.name.toLowerCase().includes(this.inputCari.toLowerCase())
			);
			
		},
		hasilPilihan(opsi){
			this.inputCari=""
			this.placeCari=opsi.name
			if(this.page.one)
				this.form.group=opsi.id
			else if(this.page.two)
				this.importContact.group =opsi.id
			else
				this.importGroup.group=opsi.id
				
			
			
		},
            async getDevice(param) {
                let res = await this.$store.dispatch("device_list_all", param);
                this.device = res.data.data.devices
            },
            async loadDeviceGroup() {
                if(!this.importGroup.device){
                    this.$toast.error("Silahkan pilih device terlebih dahulu") 
                    return
                }

                this.importGroup.loading = true
                let res = await this.$store.dispatch("contact_load_group_device", {
                    id: parseInt(this.importGroup.device)
                });
                
                this.importGroup.loadedGroup = res.data.data.groups
                // Ensure all groups have name property, if not use id as fallback
                for (let i = 0; i < this.importGroup.loadedGroup.length; i++) {
                    if (!this.importGroup.loadedGroup[i].name) {
                        this.importGroup.loadedGroup[i].name = this.importGroup.loadedGroup[i].id || 'Unknown Group'
                    }
                }

                this.importGroup.step++
                this.importGroup.loading = false
            },
            async cancelImportGroup(){
                this.importGroup.device = ""
                this.importGroup.step--
            },
            async syncGroup() {
                this.importGroup.loading = true
                //GET CONTACT FROM DEVICE
                let res = await this.$store.dispatch("contact_load_group_participants", {
                    id: parseInt(this.importGroup.device),
                    jid: this.importGroup.selectedGroup
                });
                let contacts = res.data.data.contacts ?? []
                let bulkContact = []

                for (let i = 0; i < contacts.length; i++) {
                    const element = contacts[i];

                    if (!element.id) continue

                    if(!element.name) element.name = element.id

                    bulkContact.push({
                        name: element.name,
                        number: element.id,
                    })
                }

                try {
                    let response = await this.$store.dispatch("contact_create_bulk", {
                        group: parseInt(this.importGroup.group),
                        data: bulkContact
                    });
                    this.$toast.success(response.data.message);
                    this.$root.$emit("toggle_modal", "import_contact");
                    this.$root.$emit("refresh_table", true);
                    this.importGroup.loading = false
                } catch (err) {
                    this.$toast.error(err.response.data.message);
                }
            },
            async syncContactGroup() {
                this.importContact.loading = true
                //GET CONTACT FROM DEVICE
                let res = await this.$store.dispatch("contact_load_from_device", {
                    id: parseInt(this.importContact.device)
                });
                let contacts = res.data.data.contacts
                let bulkContact = []

                for (let i = 0; i < contacts.length; i++) {
                    const element = contacts[i];

                    if (element.is_group) continue
                    if (!element.name || !element.number) continue

                    bulkContact.push({
                        name: element.name,
                        number: element.number,
                    })
                }

                try {
                    let response = await this.$store.dispatch("contact_create_bulk", {
                        group: parseInt(this.importContact.group),
                        data: bulkContact
                    });
                    this.$toast.success(response.data.message);
                    this.$root.$emit("toggle_modal", "import_contact");
                    this.$root.$emit("refresh_table", true);
                    this.importContact.loading = false
                } catch (err) {
                    this.$toast.error(err.response.data.message);
                }
            },
            async readFile() {
                let file = event.target.files[0];
                if (file.type != "text/csv") {
                    this.$toast.error("File harus .csv")
                    return
                }

                this.importData = []
                this.csvImportReady = false
                this.csvParseLoading = true

                try {
                    let result = await this.papaParseAsync(file);
                    await this.arrayToData(result)

                    if (this.importData.length != 0) this.csvImportReady = true
                } catch (err) {
                    this.$toast.error(err);
                }
                this.csvParseLoading = false
            },
            arrayToData(array) {
                if (!array || array.length === 0) return;

                const headerRow = array[0].map(item =>
                    (item || "").toString().trim().toLowerCase()
                );
                const birthDateIndex = headerRow.findIndex(header =>
                    ["tgl lahir", "tanggal lahir", "birth date", "birthdate"].includes(header)
                );

                // const startIndex = birthDateIndex !== -1 ? 1 : 0;

                for (let i = 1; i < array.length; i++) {
                    const row = array[i];
                    if (!row) continue;

                    const rawName = row[0];
                    const rawNumber = row[1];
                    if (rawName === "" || rawName === undefined) continue;
                    if (rawNumber === "" || rawNumber === undefined) continue;

                    const name = rawName?.toString().trim();
                    const number = rawNumber?.toString().trim();
                    if (!name || !number) continue;

                    let variable = [];
                    let varcount = 1;
                    for (let j = 2; j < 10; j++) {
                        if (j === birthDateIndex) continue;
                        const value = row[j];
                        if (value !== "" && value !== undefined && value !== null) {
                            variable.push({
                                id: varcount,
                                value: value
                            })
                        }
                        varcount++
                    }

                    let birthDate = null;
                    if (birthDateIndex !== -1) {
                        birthDate = this.normalizeCsvBirthDate(row[birthDateIndex]);
                    }

                    const payload = {
                        name,
                        number,
                        variable
                    };

                    if (birthDate) {
                        payload.birth_date = birthDate;
                    }

                    this.importData.push(payload)
                }
            },
            papaParseAsync(file) {
                return new Promise((resolve, reject) => {
                    this.$papa.parse(file, {
                        header: false,
                        complete(results) {
                            resolve(results.data)
                        },
                        error(err, ) {
                            reject(err)
                        }
                    })
                })
            },
            normalizeCsvBirthDate(value) {
                if (value === undefined || value === null) return null;
                const str = value.toString().trim();
                if (!str) return null;

                if (/^\d{4}-\d{2}-\d{2}$/.test(str)) {
                    return str;
                }

                const parts = str.split(/[-/]/);
                if (parts.length === 3) {
                    let [day, month, year] = parts.map(part => part.toString().trim());
                    if (year.length === 2) {
                        year = year < "50" ? `20${year}` : `19${year}`;
                    }
                    const iso = `${year.padStart(4, "0")}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
                    if (!isNaN(Date.parse(iso))) {
                        return iso;
                    }
                }

                return null;
            },
            async addContact() {
                this.csvParseLoading = true
                try {
                    let response = await this.$store.dispatch("contact_create_bulk", {
                        group: this.form.group,
                        data: this.importData
                    });
                    this.$toast.success(response.data.message);
                    this.$root.$emit("toggle_modal", "import_contact");
                    this.$root.$emit("refresh_table", true);
                } catch (err) {
                    this.$toast.error(err.response.data.message);
                }
                this.csvParseLoading = false
            },
            changePage(page) {
                this.page.one = false
                this.page.two = false
                this.page.three = false

                if (page == "one") this.page.one = true
                if (page == "two") this.page.two = true
                if (page == "three") this.page.three = true
            },
            updateFormGroup(option) {
                this.form.group = option ? option.id : null
            },
            updateImportContactGroup(option) {
                this.importContact.group = option ? option.id : null
            },
            updateImportGroupSelectedGroup(option) {
                this.importGroup.selectedGroup = option ? option.id : null
                // Keep the full object for display
                this.selectedGroupForImportGroup = option
            },
            updateImportGroupGroup(option) {
                this.importGroup.group = option ? option.id : null
            }
        },
    };
</script>

<style scoped>
    #ulCari{border:1px solid #CCC;padding:10px;margin-top:10px;border-radius:5px}
    #ulCari li{padding:3px;border-radius:5px}
	#ulCari li:hover{background:#337aff;color:white}
    .spinner {
        height: 1rem !important;
        width: 1rem !important;
    }

    .btn-spinner {
        line-height: 1rem !important;
    }

    .nav-link {
        cursor: pointer !important;
    }
</style>